// Laravel formatter
const formatter = {
  interpolate(message, values) {
    if (values === null || values === undefined) {
      return [message]
    }

    // Mirror Laravel's str_replace interpolation: longest variable first, and no word
    // boundary, so a translation can glue text straight onto a placeholder. Danish forms
    // the genitive that way — ":companys" must render as "Randstads".
    for (const variable of Object.keys(values).sort((a, b) => b.length - a.length)) {
      message = message.split(`:${variable}`).join(values[variable])
    }
    return [message]
  },
}

// TODO: Move this Language fix to the backend, or run a script fixing the json files for null values
function fixLang(key, value) {
  return value === null ? key : value
}

// Fix inconsistencies in json files
function fixJson(json) {
  for (const prop in json) {
    json[prop] = fixLang(prop, json[prop])
  }
  return json
}

for (const lang in window.i18n) {
  window.i18n[lang] = fixJson(JSON.parse(window.i18n[lang]))
}

const $t = (key, values = {}) => {
  // for some reason we don't have our translation files
  if (!window.i18n || !window.i18n[currentLanguageSelected]) {
    return key
  }
  const message = window.i18n[currentLanguageSelected][key]
  return formatter.interpolate(message || key, values)[0]
}

const $tc = (key, count, values = {}) => {
  // for some reason we don't have our translation files or the key is broken
  if (!window.i18n || !window.i18n[currentLanguageSelected]) {
    return key
  }
  const message = window.i18n[currentLanguageSelected][key] ?? key
  try {
    const [singular, plural] = message.split(' | ')
    const msg = (count === 1 ? singular : plural) ?? singular ?? plural ?? key

    return formatter.interpolate(msg, { count, ...values })[0]
  } catch (e) {
    return key
  }
}

window.$t = $t
window.$tc = $tc

function setUpInternationalization(app) {
  app.mixin({
    methods: {
      $t,
      $tc,
    },
  })
}

export { $t, $tc, formatter, setUpInternationalization }
